import { images } from 'ionic-ui';
import React from 'react';
import ResponsiveImage from '../../../responsive-image/ResponsiveImage';

export function ProductCardSkeleton() {
  return (
    <div className="p-4 rounded-sm border border-border flex flex-col w-full gap-3">
      <div className="w-full relative">
        <ResponsiveImage
          className="rounded-sm bg-gray-100 animate-pulse border border-gray-100"
          src={images.placeholder}
          aspectRatio={1}
        />
      </div>
      <div className="flex-1 space-y-3 w-full">
        <span className="block px-3 py-0.5 rounded-sm w-1/2 bg-gray-100 animate-pulse">
          <small className="text-gray-100">placeholder</small>
        </span>
        <h6 className="font-semibold text-gray-100 bg-gray-100 animate-pulse w-1/2">
          placeholder
        </h6>
      </div>
      <div className="space-y-3">
        <p className="text-gray-100 bg-gray-100 animate-pulse w-fit">NNNNNNN</p>
        <small className="block bg-gray-100 animate-pulse text-gray-100">
          placeholder
        </small>
      </div>
      <div className="flex flex-wrap gap-2 w-full product-card-action-btns">
        <div className="h-10 flex-1 rounded-md bg-gray-100 animate-pulse"></div>
        <div className="h-10 flex-1 rounded-md bg-gray-100 animate-pulse"></div>
      </div>
    </div>
  );
}
